import React from 'react';
import {  useParams } from 'react-router-dom';
import { formatMessage } from '../../../../../locale';
import {
  ListContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from './TeamList.style';
import PaginableList from '../../../../../ui-kit/PaginableListSurveyView';
import { useGetCourseProgressQuery } from '../../../../../slices/dashboardApiSlice';
import Spinner from '../../../../../ui-kit/Spinner/Spinner';

export const TeamList = () => {
  const { courseId } = useParams<{ courseId: string }>()


  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState('');


  return (
    <PaginableList
      query={useGetCourseProgressQuery}
      id={courseId}
      currentPage={currentPage}
      searchTerm={searchTerm}
    >
      {(courses, isLoading, error) => {
        if (isLoading) return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}><Spinner/></div>;
        if (error) return <div  style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh'}}> <h1>{formatMessage({ id: 'loading.errorLoadingCourseDashboard', defaultMessage: 'Error while loading course' })}</h1></div>;

        return (
          <>
          {courses?.length > 0 ? (
            <div style={{ padding: '20px', border: '' }}>
              <ListContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>
                        {formatMessage({ id: 'dashboardCourse.columnsView.userName', defaultMessage: 'User name' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.courseStarted', defaultMessage: 'Course started' })}
                      </Th>
                      <Th>
                        {formatMessage({ id: 'dashboardCourse.columnsView.completed', defaultMessage: 'Completed' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.attemptToComplete', defaultMessage: 'Attempt to complete' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.dateCompleted', defaultMessage: 'Date completed' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.deadline', defaultMessage: 'Deadline' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.manager', defaultMessage: 'Manager' })}
                      </Th>
                      <Th>
                        {formatMessage({ id: 'dashboardCourse.columnsView.department', defaultMessage: 'Department' })}
                      </Th>
                      <Th style={{ textAlign: 'center' }}>
                        {formatMessage({ id: 'dashboardCourse.columnsView.whiteBlueCollar', defaultMessage: 'White/Blue collar' })}
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {courses.map((course: any) => (
                      <Tr key={course.id}>
                        <Td style={{ fontSize: '0.9rem' }}>{course?.user_name}</Td>
                        <Td style={{ textAlign: 'center', fontSize: '0.9rem' }}>{course?.started_at}</Td>
                        <Td style={{ textAlign: 'center' }}>
                          {course?.status === 'completed'
                            ? formatMessage({ id: 'dashboardCourse.yes', defaultMessage: 'Yes' })
                            : formatMessage({ id: 'dashboardCourse.no', defaultMessage: 'No' })}
                        </Td>
                        <Td style={{ textAlign: 'center' }}>{course?.quiz_attempts || '0'}</Td>
                        <Td style={{ textAlign: 'center', fontSize: '0.9rem' }}>{course?.date_complete}</Td>
                        <Td style={{ textAlign: 'center', fontSize: '0.9rem' }}>{course?.expired_at || ''}</Td>
                        <Td style={{ fontSize: '0.9rem' }}>{course?.manager}</Td>
                        <Td style={{ fontSize: '0.9rem' }}>{course?.department}</Td>
                        <Td style={{ textAlign: 'center', fontSize: '0.9rem' }}>
                          {course?.color === 'blue'
                            ? formatMessage({ id: 'dashboardCourse.blueColor', defaultMessage: 'Blue collar' })
                            : formatMessage({ id: 'dashboardCourse.whiteColor', defaultMessage: 'White collar' })}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </ListContainer>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
              <h1>{formatMessage({ id: 'task.noCourses', defaultMessage: 'No courses available' })}</h1>
            </div>
          )}
        </>
        );
      }}
    </PaginableList>
  );
};

export default TeamList;
